
    var riot = require('riot')
    
import vars from '@/vars'
riot.tag2('collection-contents', '<div class="collection__wrap" if="{mode == &quot;pc&quot;}"> <div class="collection__wrap-inner"> <div class="collection__banners"> <ul> <li each="{opts.store.collection_contents}" if="{hrefCheck(href)}"><a href="{href}" target="_blank"> <dl> <dt class="img lazybg" data-src="{img}"></dt> <dd class="name"> <riot-md str="{name}"></riot-md> </dd> </dl></a></li> </ul> </div> <ul class="collection__btns"> <li class="collection__btns-item bn-go-biwako" data-cid="go-biwako"><a href="https://en.biwako-visitors.jp/">go.biwako</a> <ul class="lang-set"> <li><a href="https://en.biwako-visitors.jp/"><span>ENGLISH</span></a></li> <li><a href="https://cn.biwako-visitors.jp/"><span>簡体中文</span></a></li> <li><a href="https://tw.biwako-visitors.jp/"><span>繁体中文</span></a></li> <li><a href="https://kr.biwako-visitors.jp/"><span>한국어</span></a></li> </ul> </li> <li class="collection__btns-item bn-hanasaijiki" data-cid="hanasaijiki"><a href="/hanasaijiki/">しがの花歳時記</a></li> </ul> </div> </div>', '', '', function(opts) {

    const self = this
    console.log(self)

    this.hrefCheck = function(href){
      switch (href) {
        case '':
        case null:
          return false
        default:
          return true
      }
    }.bind(this)

    self.on('mount', () => {
      vars.uacheck(self)
      self.update()

      $(".lazybg", self.root).Lazy({
        effect: 'fadeIn',
        effectTime: 400
      })

      if( self.mode == "sp" ) {
        self.unmount()
      }
    })
});
    
  


// WEBPACK FOOTER //
// ./_src/js/riot/collection-contents.tag